import { gql } from '@apollo/client';

export const APPROVE_INVOICES_FROM_ACTIVE_PROVIDERS = gql`
  mutation approveInvoicesFromActiveProviders($businessId: ID!) {
    approveInvoicesFromActiveProviders(businessId: $businessId) {
      id
    }
  }
`;
